import { render, staticRenderFns } from "./preloader-new.vue?vue&type=template&id=8bf0b952&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bf0b952')) {
      api.createRecord('8bf0b952', component.options)
    } else {
      api.reload('8bf0b952', component.options)
    }
    module.hot.accept("./preloader-new.vue?vue&type=template&id=8bf0b952&", function () {
      api.rerender('8bf0b952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/preloader/preloader-new.vue"
export default component.exports